import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'atw-countdown-admin',
  templateUrl: './countdown-admin.component.html',
  styleUrls: ['./countdown-admin.component.scss']
})
export class AtwCountdownAdmin implements OnInit {

  constructor(private vhQueryAutoWeb: VhQueryAutoWeb,private message: NzMessageService,private datePipe: DatePipe) { }
  @Input() data: any;
  dataAfterChange: any  = {}
  checkEnd = true;
  date_end = new Date();
  date = new Date();
  dateStart :String;
  dateEnd :String;
  checkTimeIsCorrect = true;//check xem lấy ngày bắt đầu và ngày kết thúc đúng không
  data_object:any = {
    data: {},
  };
  ngOnInit(): void {
  
    this.data_object.data = this.data.data;
    
    if(this.data_object.data.date_start)
    this.setFormatDay()
  }
  setFormatDay()
    {
      const dateS = new Date(this.data_object.data.date_start);
      const dateE = new Date(this.data_object.data.date_end);
      const dateSetting = this.datePipe.transform(dateS, 'yyyy-MM-ddTHH:mm');
      this.dateStart = dateSetting.substring(0, 16);
      const dateSetting1 = this.datePipe.transform(dateE, 'yyyy-MM-ddTHH:mm');
      this.dateEnd = dateSetting1.substring(0, 16);
    }
  
  updateDynamic(name,value) {
    this.dataAfterChange[name] = value;
    

  }
  CheckDayInput(date:any)
  {
  this.date = new Date(date);
  const currentDate = new Date();
  currentDate.setHours(0,0,0,0);
  if(this.date < currentDate)
  {
  this.checkTimeIsCorrect = true;
  this.createMessage('Ngày cài đặt bắt đầu không hợp lệ');
  }
  else
  {
  if(this.data_object.data.date_end)
  {
  this.checkTimeIsCorrect = false;
  this.dateEnd = this.datePipe.transform(this.date_end, 'yyyy-MM-ddTHH:mm');
  }
  this.data_object.data.disabled = false;
  this.dateStart = this.datePipe.transform(this.date, 'yyyy-MM-ddTHH:mm');
  }
  }
  CheckDayEnd(date:any)
  {
  const currentDate = new Date();
  this.date_end = new Date(date);
  if(this.date > this.date_end && this.date_end > currentDate)
  {
  this.createMessage('Ngày cài đặt kết thúc không hợp lệ');
  this.checkTimeIsCorrect=true;
  }
  else
  {
  this.checkTimeIsCorrect = false;
  this.data_object.data.date_end = this.date_end;
  this.dateEnd = this.datePipe.transform(this.date_end, 'yyyy-MM-ddTHH:mm');
  }

  }
  createMessage(info:any): void {
  this.message.error(info);
  }
  SetTime() {
  this.checkTimeIsCorrect = !this.checkTimeIsCorrect;
  this.data_object.data.date_start = this.date;
  this.update(this.data_object.data)
  }
  
  update(value) {
  this.vhQueryAutoWeb.updateObject(this.data._id, this.data_object)
  .then((bool) => {
  
  }, error => {
  console.error(error)
  })}
}
